<template>
    <div class="w-full">
	    <div class="grid grid-cols-1 lg:grid-cols-3 gap-y-8 gap-x-8">
	    	<div>
		        <label class="block text-sm mb-1 font-bold" for="password">Current Password</label>
		        <div class="toggle-password-view form-input p-0 mb-5">
		            <input
		                id="current-password"
		                type="password"
		                class="form-input w-10/12 pl-2 border-0 shadow-none inline"
		                name="current_password"
		                required
		                autocomplete="current-password"
		                v-model="currentPassword"
		            />
		            <a
		                @click.prevent="showCurrentPassword = !showCurrentPassword"
		                href="#"
		                class="inline eye-toggle"
		                role="button"
		            >
		                <i v-if="showCurrentPassword" class="far fa-eye"></i>
		                <i v-if="!showCurrentPassword" class="far fa-eye-slash"></i>
		            </a>
		        </div>
			</div>
			<div>
		        <label class="block text-sm mb-1 font-bold" for="password">New Password</label>
		        <div class="toggle-password-view form-input p-0 mb-5">
		            <input
		                id="password"
		                type="password"
		                class="form-input w-10/12 pl-2 border-0 shadow-none inline"
		                name="password"
		                required
		                autocomplete="new-password"
		                v-model="password"
		                @keyup="validatePassword"
		            />
		            <a
		                @click.prevent="showPassword = !showPassword"
		                href="#"
		                class="inline eye-toggle"
		                role="button"
		            >
		                <i v-if="showPassword" class="far fa-eye"></i>
		                <i v-if="!showPassword" class="far fa-eye-slash"></i>
		            </a>
		        </div>
		        <password-meter :password="password" />
		        <div v-if="passwordIsGreat" class="py-2 text-green-500 text-sm font-bold">
		            <i class="fal fa-check-circle"></i> Your password is great!
		        </div>
		        <ul v-if="password.length > 0 && !passwordIsGreat" class="pt-1 mb-5">
		            <li>
		                <span v-if="passwordCheckList.hasLength" class="text-green-500 text-sm font-bold"
		                    ><i class="fas fa-check fa-fw"></i> Password length is good. The longer the
		                    better.</span
		                >
		                <span v-if="!passwordCheckList.hasLength" class="text-red-700 text-sm"
		                    ><i class="fal fa-times fa-fw"></i> Password needs to be
		                    <strong>at least 9 characters</strong>.</span
		                >
		            </li>
		            <li>
		                <span v-if="passwordCheckList.hasAlpha" class="text-green-500 text-sm font-bold"
		                    ><i class="fas fa-check fa-fw"></i> Password has at least one number.</span
		                >
		                <span v-if="!passwordCheckList.hasAlpha" class="text-red-700 text-sm">
		                    <i class="fal fa-times fa-fw"></i> Password requires
		                    <strong>at least one number</strong>.</span
		                >
		            </li>
		            <li>
		                <span v-if="passwordCheckList.hasCase" class="text-green-500 text-sm font-bold"
		                    ><i class="fas fa-check fa-fw"></i> Password has upper &amp; lower
		                    characters.</span
		                >
		                <span v-if="!passwordCheckList.hasCase" class="text-red-700 text-sm"
		                    ><i class="fal fa-times fa-fw"></i> Password requires
		                    <strong>upper &amp; lower case</strong> characters.</span
		                >
		            </li>
		            <li>
		                <span v-if="passwordCheckList.hasSpecial" class="text-green-500 text-sm font-bold"
		                    ><i class="fas fa-check fa-fw"></i> Password has at least one special
		                    character.</span
		                >
		                <span v-if="!passwordCheckList.hasSpecial" class="text-red-700 text-sm"
		                    ><i class="fal fa-times fa-fw"></i> Password requires at least
		                    <strong>one special</strong> character.<br /><span class="block ml-8 text-sm"
		                        >(! @ # $ % ^ & * ( ) _ + - [ ] . ?)</span
		                    ></span
		                >
		            </li>
		        </ul>
		
		        <label class="block text-sm font-bold mb-1" for="password-confirm"
		            >Password Confirmation</label
		        >
		        <div class="toggle-password-view form-input p-0 mb-5">
		            <input
		                id="password-confirm"
		                type="password"
		                class="form-input w-10/12 pl-2 border-0 shadow-none inline"
		                name="password_confirmation"
		                required
		                v-model="password_confirmation"
		            />
		            <a
		                @click.prevent="showPasswordConfirm = !showPasswordConfirm"
		                href="#"
		                class="inline eye-toggle"
		                role="button"
		            >
		                <i v-if="showPasswordConfirm" class="far fa-eye"></i>
		                <i v-if="!showPasswordConfirm" class="far fa-eye-slash"></i>
		            </a>
		        </div>
		        <div class="text-red-600 font-bold p-2 text-sm" v-if="passwordsMatchMessage">
		            Please make sure the passwords match.
		        </div>
		        <errors :errors="errors" />
			</div>
			<div class="flex justify-start lg:justify-end">			
		        <ActionButton
		            @clicked="changePassword"
		            label="Update Password"
		            :loading="loading"
		            classes="btn bg-navy-500 hover:bg-navy-400 text-white !mt-5"
		        />
	        </div>
		</div>
    </div>
</template>
<script>
import Auth from '@/services/auth';
import ActionButton from '@/components/action-button.vue';
import PasswordMeter from 'vue-simple-password-meter';
import Errors from '@/components/errors.vue';

export default {
    components: {
        ActionButton,
        PasswordMeter,
        Errors,
    },
    data: () => ({
        errors: [],
        saving: false,
        loading: false,
        currentPassword: '',
        password: '',
        password_confirmation: '',
        passwordCheckList: {
            hasAlpha: false,
            hasLength: false,
            hasCase: false,
            hasSpecial: false,
        },
        showCurrentPassword: false,
        showPassword: false,
        showPasswordConfirm: false,
    }),
    watch: {
        showCurrentPassword(newVal, oldVal) {
            let passwordField = document.getElementById('current-password');
            passwordField.type = newVal ? 'text' : 'password';
        },
        showPassword(newVal, oldVal) {
            let passwordField = document.getElementById('password');
            passwordField.type = newVal ? 'text' : 'password';
        },
        showPasswordConfirm(newVal, oldVal) {
            let passwordField = document.getElementById('password-confirm');
            passwordField.type = newVal ? 'text' : 'password';
        },
    },
    computed: {
        passwordIsGreat() {
            return (
                this.passwordCheckList.hasAlpha &&
                this.passwordCheckList.hasLength &&
                this.passwordCheckList.hasCase &&
                this.passwordCheckList.hasSpecial
            );
        },
        passwordsMatchMessage() {
            if (this.password.length > 7 && this.password_confirmation.length > 7) {
                if (this.password !== this.password_confirmation) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
    },
    methods: {
        changePassword() {
            this.errors = [];
            if (this.passwordsMatchMessage) {
                return false;
            }

            if (!this.passwordIsGreat) {
                this.errors.push({ message: 'Please use a strong password.' });
            }

            if (this.currentPassword.length < 5) {
                this.errors.push({ message: 'Please enter your current password.' });
            }

            if (this.errors.length === 0) {
                this.loading = true;
                let data = {
                    current_password: this.currentPassword,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                };

                const auth = Auth.changePassword(data);
                auth.then((response) => {
                    this.loading = false;
                    this.$notify(
                        {
                            group: 'success',
                            title: 'Success',
                            text: 'Password changed!',
                        },
                        5000
                    );
                }).catch((e) => {
                    this.loading = false;
                    console.log(e);
                    this.$notify(
                        {
                            group: 'error',
                            title: 'Error',
                            text: e.response.data.message,
                        },
                        5000
                    );
                });
            }
        },
        validatePassword() {
            const lowerCase = /[a-z]/;
            const upperCase = /[A-Z]/;
            const specialChars = /[!@#$%^&*()_+\-\[\].?~]/;
            let hasAlpha = /\d/.test(this.password);
            let hasSpecial = specialChars.test(this.password);
            let hasLowerCase = lowerCase.test(this.password);
            let hasUpperCase = upperCase.test(this.password);
            let hasMixedCase = hasLowerCase && hasUpperCase;
            this.passwordCheckList.hasLength = this.password.length > 8 ? true : false;
            this.passwordCheckList.hasAlpha = hasAlpha ? true : false;
            this.passwordCheckList.hasCase = hasMixedCase ? true : false;
            this.passwordCheckList.hasSpecial = hasSpecial ? true : false;
        },
    },
};
</script>
<style lang="scss" scoped>
.eye-toggle {
    width: 30px;
    height: 28px;
    vertical-align: middle;
    margin-left: 16px;
    outline: none;

    i {
        font-size: 22px;
        line-height: 1;
        color: #777;
    }
}
</style>
